import SampleProfilePolicy from './SampleProfilePolicy';
import SampleProjectPolicy from './SampleProjectPolicy';

export default {
  canSeeList(user) {
    return SampleProjectPolicy.canSeeList(user) || SampleProfilePolicy.canSeeList(user);
  },
};
